import { z } from 'zod';
import { mongoIdValidator } from '../common';

export const CipcodesDocumentSchema = z.object({
  _id: mongoIdValidator.optional(),
  cipCode: z.string(),
  cipTitle: z.string(),
});
export type CipcodesDocument = z.infer<typeof CipcodesDocumentSchema>;
